import { useViewMode } from '~/prix/react/hooks/viewMode'

const LayoutInformation = () => {
  const viewMode = useViewMode()

  return (
    <>
      <h2>Layout</h2>
      <div className='information'>
        <h3>Modo de visualização:</h3>
        <span>{viewMode ?? 'Não encontrado'}</span>
      </div>
    </>
  )
}

export default LayoutInformation
